import React from 'react';
import { Card, Col, Row, Statistic, Spin } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccSummary } from '@/hooks/useWorkstationControlCenter';

const STATUS_COLORS: Record<string, string> = {
  running: '#52c41a',
  blocked: '#ff4d4f',
  maintenance: '#722ed1',
  idle: '#8c8c8c',
};

interface Props {
  params?: WorkstationControlCenterQueryParams;
  refreshInterval?: number;
  tvMode?: boolean;
}

const ExecutiveCapacityRibbon: React.FC<Props> = ({ params, refreshInterval, tvMode }) => {
  const { data, isLoading } = useWccSummary(params, refreshInterval);
  const s = data as Record<string, number> | undefined;

  if (isLoading) return <Spin style={{ display: 'block', margin: '16px auto' }} />;

  const chips = [
    { title: 'Total workstations', value: s?.totalWorkstations, color: undefined },
    { title: 'Running', value: s?.running, color: STATUS_COLORS.running },
    { title: 'Idle', value: s?.idle, color: STATUS_COLORS.idle },
    { title: 'Blocked', value: s?.blocked, color: STATUS_COLORS.blocked },
    { title: 'Maintenance', value: s?.maintenance, color: STATUS_COLORS.maintenance },
    { title: 'Utilization %', value: s?.utilizationPercent, suffix: '%' },
    { title: 'Capacity today (h)', value: s?.capacityAvailableToday },
    { title: 'Hours worked', value: s?.hoursWorkedToday },
    { title: 'Hours remaining', value: s?.hoursRemainingToday },
    { title: 'Bottlenecks', value: s?.criticalBottlenecks, color: STATUS_COLORS.blocked },
    { title: 'Delayed ops', value: s?.delayedOperations },
    { title: 'Overloaded WS', value: s?.overloadedWorkstations },
  ];

  return (
    <Row gutter={[12, 12]} id="summary">
      {chips.map((c) => (
        <Col xs={12} sm={8} md={6} lg={tvMode ? 4 : 3} key={c.title}>
          <Card size="small" hoverable>
            <Statistic
              title={c.title}
              value={c.value ?? 0}
              suffix={c.suffix}
              valueStyle={{
                fontSize: tvMode ? 26 : undefined,
                color: c.color,
              }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ExecutiveCapacityRibbon;
